export default function skipConditionText(condition) {
	// TODO: Convert to map
	switch (condition) {
	case "CAMPAIGN_DUPLICATE":
		return "Leads are already in campaign";
	case "DUPLICATE":
		return "Same leads found in other campaigns";
	case "TEAM_DUPLICATE":
		return "Same leads found in campaigns of your team members";
	case "NO_PHOTO":
		return "No photo on lead’s profile";
	case "LESS_THAN_500_CONNECTIONS":
		return "Less than 500 connections";
	case "FREE_ACCOUNT":
		return "Has a free LinkedIn account";
	case "IS_NOT_OPEN_PROFILE":
		return "Does not have an open profile";
	case "UNKNOWN_LEAD":
		return "Invalid LinkedIn profile";
	case "IS_CURRENT_USER":
		return "Lead is current user";
	case "BATCH_DUPLICATE":
		return "Duplicate entries found";
	default:
		return "";
	}
}
